import React from 'react';
import TownCentreIcon from '../../atoms/icons/towncentre';
import { Link } from 'gatsby';
import { getLink } from '../../../utils/link';
import { HotelUtility } from '../../hotel/hotel_title';
import { trackEvent } from '../../../utils/tracking';

const GoogleMapMarker = ({ blok = null, text, hotel, expanded = false }) => {
  return (
    <div
      className={` ${
        expanded ? 'bg-yellow-60' : 'bg-transparent hover:bg-yellow-60'
      } font-crystalCondensed flex items-center absolute top-0 right-0 z-0 hover:z-10 hover:drop-shadow-2xl  rounded-full group `}
    >
      <MarkerWrapper hotel={hotel} expanded={expanded}>
        {blok ? blok.text_marker : text}
      </MarkerWrapper>

      <span className="hover:bg-transparent bg-yellow-60 px-5 py-4 rounded-full">
        <TownCentreIcon />
      </span>
    </div>
  );
};

const MarkerWrapper = ({ hotel, children, expanded }) => {
  if (hotel && !expanded) {
    return (
      <Link
        to={getLink(hotel.full_slug)}
        onClick={() => trackEvent('map_marker_click', { hotel: hotel.name })}
        className={`hidden group-hover:block whitespace-nowrap text-lg pl-5 py-4 no-underline`}
      >
        <HotelUtility hotel={hotel} textStyle={'marker'} />
      </Link>
    );
  } else {
    return (
      <span
        className={`${
          !expanded ? 'hidden group-hover:block' : 'block'
        }  whitespace-nowrap text-lg px-5 py-4 no-underline `}
      >
        {children}
      </span>
    );
  }
};

export default GoogleMapMarker;
